import DepartmentRouter from './department/router'; // 分属部门
import ThreadRouter from './thread/router'; // 线索管理
import BusinessRouter from './business/router'; // 商机管理
import CustomRouter from './custom/router'; // 商机管理

const router = {
  path: 'crm',
  breadcrumbName: '商机管理',
  childRoutes: [DepartmentRouter, ThreadRouter, BusinessRouter, CustomRouter],
};
export default router;



// WEBPACK FOOTER //
// ./src/components/crm/router.js